import React, { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { uniqueId } from 'lodash';
import styled from 'styled-components';

import { Sheet } from '@r1-frontend/ui-react/components/Modal';
import { SingleArrowUp } from '@r1-frontend/ui-react/components/svg/arrows';
import { createRootElement } from '@r1-frontend/shared/helpers/dom';

export type TStickyBottomSheetProps = {
    children: ReactNode,
    onClick: () => void,
    id?: string,
}

const StickyBottomSheet = ({ children, id, ...props }: TStickyBottomSheetProps): React.ReactPortal | null => {
    const [popupRoot, setPopupRoot] = useState<HTMLElement | null>(null);

    useEffect(() => {
        const root = createRootElement(`sticky-bottom-sheet-${id ? id : uniqueId()}`);
        setPopupRoot(root);

        return () => {
            popupRoot && popupRoot.remove();
        };
    }, []);

    return popupRoot
        ? createPortal(
            <div {...props}>
                <Sheet Icon={SingleArrowUp}>
                    {children}
                </Sheet>
            </div>,
            popupRoot,
        )
        : null;
};

export default styled(StickyBottomSheet)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;

    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    visibility: visible;

    ${Sheet} {
        // 52px for right indent is summarize of open button width (28px) / 8px gap from button / 16px default indent from right side
        padding: 16px 52px 16px 16px;
    }
`;
